document.addEventListener("DOMContentLoaded", () => {
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  const isMac = /Macintosh/.test(navigator.userAgent);

  document.body.classList.add(isIOS ? "ios" : "no-ios");

  const interval = setInterval(() => {
    const container = document.querySelector("#container-express-checkout");
    const checkoutArea = document.querySelector('[data-rebuy-component="checkout-area"]');
    const checkoutButton = checkoutArea?.querySelector(".rebuy-cart__checkout-button");

    if (container && checkoutArea && checkoutButton) {
      checkoutArea.insertBefore(container, checkoutButton);

      // Detectar si el botón de Apple Pay existe
      const applePayButton = container.querySelector("shopify-apple-pay-button");

      // Ajustar altura dinámica según existencia del botón
      if (applePayButton) {
        container.style.maxHeight = "128px";
      } else {
        container.style.maxHeight = "68px";
      }

      // Revalidar si el botón aparece tarde (por carga asíncrona)
      const observer = new MutationObserver(() => {
        const applePayExists = !!container.querySelector("shopify-apple-pay-button");
        container.style.maxHeight = applePayExists ? "128px" : "68px";
      });

      observer.observe(container, { childList: true, subtree: true });

      clearInterval(interval);
    }
  }, 300);

  setTimeout(() => clearInterval(interval), 10000);
});
